
// هذا الملف الآن يعتمد على environment-config.ts
// يتم تحديد البيئة ديناميكياً في main.ts

export const environment = (window as any).environment || {
  production: false,
  RootDomain: "glamera.com",
  AppDomain: "dev.glamera.com",
  ApiUrl: "https://api-dev.glamera.com/api/",
  NewApiUrl: "https://api-dev-new.glamera.com/api/",
  ApiUrlV2: "https://api-dev.glamera.com/api/v2/",
};
